// extracted by mini-css-extract-plugin
export default {"main":"styles_main__cLb+A","h2":"styles_h2__esgWa","buttonup":"styles_buttonup__9ja78","space":"styles_space__J7t3z"};